"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.convertDate = convertDate;
exports.getCustomerPriceValue = exports.getBasePriceValue = void 0;
exports.getLocale = getLocale;
exports.sessionGetItem = exports.getStockAvailability = void 0;
var _react = _interopRequireDefault(require("react"));
var _Availability = _interopRequireDefault(require("../../Molecules/Availability"));
var _lodash = require("lodash");
var _common = require("../../../core/utils/common");
var _SKUTiles = require("../SKUTiles/SKUTiles.constant");
var session = window.sessionStorage;
var sessionGetItem = function sessionGetItem(prop) {
  if (!session) {
    return null;
  }
  var value = session.getItem(prop);
  return value ? JSON.parse(value) : null;
};
exports.sessionGetItem = sessionGetItem;
var getTitleDescription = function getTitleDescription(condition, primary, secondary) {
  return condition ? primary : secondary;
};
var getBasePriceValue = function getBasePriceValue(productItem, includeTaxWithPrice) {
  if (productItem === void 0) {
    productItem = {};
  }
  if (includeTaxWithPrice === void 0) {
    includeTaxWithPrice = false;
  }
  var _productItem = productItem,
    _productItem$basePric = _productItem.basePrice,
    basePrice = _productItem$basePric === void 0 ? {} : _productItem$basePric,
    _productItem$basePric2 = _productItem.basePriceWithTax,
    basePriceWithTax = _productItem$basePric2 === void 0 ? {} : _productItem$basePric2;
  var formattedValue = basePriceWithTax.formattedValue;
  if (includeTaxWithPrice && typeof formattedValue !== 'undefined') {
    return basePriceWithTax;
  }
  return basePrice;
};
exports.getBasePriceValue = getBasePriceValue;
var getCustomerPriceValue = function getCustomerPriceValue(productItem, includeTaxWithPrice) {
  if (productItem === void 0) {
    productItem = {};
  }
  if (includeTaxWithPrice === void 0) {
    includeTaxWithPrice = false;
  }
  var _productItem2 = productItem,
    _productItem2$custome = _productItem2.customerPrice,
    customerPrice = _productItem2$custome === void 0 ? {} : _productItem2$custome,
    _productItem2$custome2 = _productItem2.customerPriceWithTax,
    customerPriceWithTax = _productItem2$custome2 === void 0 ? {} : _productItem2$custome2;
  var formattedValue = customerPriceWithTax.formattedValue;
  if (includeTaxWithPrice && typeof formattedValue !== 'undefined') {
    return customerPriceWithTax;
  }
  return customerPrice;
};
exports.getCustomerPriceValue = getCustomerPriceValue;
function convertDate(dateStr, userLocale) {
  if (userLocale === void 0) {
    userLocale = 'en-US';
  }
  if (dateStr && dateStr !== '0000-00-00') {
    var splitDate = dateStr.split('-');
    var constructedDate = new Date(Date.UTC(splitDate[0], parseInt(splitDate[1], 10) - 1, splitDate[2], 12));
    return constructedDate.toLocaleDateString(userLocale, {
      month: 'long',
      day: 'numeric'
    });
  } else {
    return '-';
  }
}
function getLocale() {
  var userDetails = sessionGetItem('waters.userDetails') || {};
  var localeCountry = userDetails.localeCountry || 'US';
  var localeLanguage = userDetails.localeLanguage || 'en';
  return localeLanguage + '-' + localeCountry.toUpperCase();
}
var getStockAvailability = function getStockAvailability(productItem, labels, config, quoteData) {
  var product = productItem.product;
  var stockLevelStatus = (0, _lodash.isEmpty)(quoteData) ? (0, _lodash.get)(product, 'stock.stockLevelStatus', '') : (0, _lodash.get)(productItem, 'stock.stockLevelStatus', '');
  var quantity = (0, _lodash.get)(productItem, 'quantity', '');
  var stockLevel = (0, _lodash.isEmpty)(quoteData) ? (0, _lodash.get)(product, ['stock', 'stockLevel']) : (0, _lodash.get)(productItem, 'stock.stockLevel', '');
  var restockDate = (0, _lodash.isEmpty)(quoteData) ? (0, _lodash.get)(product, 'stock.restockDate') : (0, _lodash.get)(productItem, 'stock.restockDate', '');
  var shippingDate = (0, _lodash.isEmpty)(quoteData) ? (0, _lodash.get)(product, 'stock.shippingDate') : (0, _lodash.get)(productItem, 'stock.shippingDate', '');
  var additionalInfo = (0, _lodash.isEmpty)(quoteData) ? (0, _lodash.get)(product, 'stock.additionalInfo') : (0, _lodash.get)(productItem, 'stock.additionalInfo', '');
  var formatShippingDate = convertDate(shippingDate, getLocale());
  var formatRestockDate = convertDate(restockDate, getLocale());
  if (stockLevelStatus === _SKUTiles.temporarilyOutOfStock) {
    return _react.default.createElement(_Availability.default, {
      title: getTitleDescription(restockDate, '', labels.contactWaters),
      description: getTitleDescription(restockDate, labels.estimatedToShip + " " + formatRestockDate, labels.forAvailability),
      elementLocator: "temp-out-of-stock"
    });
  }
  if (stockLevelStatus === _SKUTiles.outOfStock) {
    return _react.default.createElement(_Availability.default, {
      labels: getTitleDescription(additionalInfo, '', labels.contactWaters),
      description: getTitleDescription(additionalInfo, labels.estimatedShipDates, labels.forAvailability),
      elementLocator: "out-of-stock"
    });
  }
  if (stockLevelStatus === _SKUTiles.partialInStock && restockDate !== '') {
    return _react.default.createElement(_Availability.default, {
      className: "partial-stock-availability",
      labels: getTitleDescription(shippingDate, '', labels.partialStock),
      description: getTitleDescription(shippingDate, stockLevel + " " + labels.estimatedToShip + " " + formatShippingDate, (0, _common.getLabelWithParam)(labels.partialStockAvailable, [stockLevel])),
      descriptions: getTitleDescription(shippingDate, quantity - stockLevel + " " + labels.estimatedToShip + " " + formatRestockDate, ''),
      icon: getTitleDescription(shippingDate, '', config.unavailableIconUrl),
      elementLocator: "partial-stock"
    });
  }
  if (stockLevelStatus === _SKUTiles.partialInStock && restockDate === '') {
    return _react.default.createElement(_Availability.default, {
      className: "partial-stock-availability",
      labels: getTitleDescription(shippingDate, '', labels.partialStock),
      description: getTitleDescription(shippingDate, stockLevel + " " + labels.estimatedToShip + " " + formatShippingDate, (0, _common.getLabelWithParam)(labels.partialStockAvailable, [stockLevel])),
      descriptions: getTitleDescription(shippingDate, labels.remaingShipDates, ''),
      icon: getTitleDescription(shippingDate, '', config.unavailableIconUrl),
      elementLocator: "partial-in-stock"
    });
  }
  return _react.default.createElement(_Availability.default, {
    labels: getTitleDescription(shippingDate, '', labels.inStock),
    description: getTitleDescription(shippingDate, labels.estimatedToShip + " " + formatShippingDate, labels.orderNow),
    icon: getTitleDescription(shippingDate, '', config.successIconUrl),
    elementLocator: "in-stock"
  });
};
exports.getStockAvailability = getStockAvailability;